import { AuthUserRoutes } from "pages/authUser/routes";
import {
  UserWithImpersonationRightsRoutes,
  UserWithLinkedContactRoutes,
} from "pages/userWithLinkedContact/routes";
import { DetailProvider } from "providers/ContractIdProvider";
import { useKeycloak } from "providers/KeycloakProvider";
import { PersistedApolloProvider } from "providers/PersistedApolloProvider";
import { useLocation } from "react-router-dom";
import { logger } from "utils/logger";
import { NotFoundView } from "views/notFoundView/notFoundView";

const NoLinkedContactStack = () => (
  <PersistedApolloProvider>
    <AuthUserRoutes />
  </PersistedApolloProvider>
);

const DefaultStack = () => (
  <PersistedApolloProvider>
    <DetailProvider>
      <UserWithLinkedContactRoutes />
    </DetailProvider>
  </PersistedApolloProvider>
);

const ImpersonationStack = () => (
  <PersistedApolloProvider>
    <DetailProvider>
      <UserWithImpersonationRightsRoutes />
    </DetailProvider>
  </PersistedApolloProvider>
);

/**
 * Returns the remaining application stack
 * and deducts which routes to expose to the user.
 */
export const NavigationStack = () => {
  const keycloak = useKeycloak();
  logger.log("NavigationStack Keycloak state:", keycloak);
  const { linkedContact, impersonating } = keycloak;
  const location = useLocation();

  // Only use ImpersonationStack when actually at an /impersonate/ URL.
  // Users with both a linkedContact and impersonation rights should see their
  // own portfolio via DefaultStack when not navigating an impersonation URL.
  const isImpersonateRoute = location.pathname.startsWith("/impersonate/");

  if (impersonating && isImpersonateRoute) return <ImpersonationStack />;
  if (linkedContact) return <DefaultStack />;
  if (impersonating) return <NoLinkedContactStack />;
  return <NotFoundView />;
};
